import { useAuth0 } from "@auth0/auth0-react"
import { isMockAuth, mockAuthHeaders } from "~/utils/mockAuth"

const sessionStart = new Date().toISOString()

export function parseFileName(contentDisposition: string | null): string | undefined {
  return contentDisposition?.match(/filename="([^"]+)"/)?.[1]
}

async function errorMessage(response: Response, fallback: string): Promise<string> {
  const body = (await response.json().catch(() => undefined)) as
    | { error?: { message?: string } }
    | undefined
  return body?.error?.message ?? fallback
}

// POST to a /download/* handler. Those sit outside tRPC and so outside its auth link and error
// formatter, so the headers are rebuilt here and a non-2xx body is unwrapped into an Error the
// caller can show as is.
export function useDownloadRequest(): (
  url: string,
  body: unknown,
  fallbackMessage: string,
) => Promise<Response> {
  const { getAccessTokenSilently } = useAuth0()
  const isTestMode = isMockAuth()

  return async (url, body, fallbackMessage) => {
    const headers: Record<string, string> = {
      "content-type": "application/json",
      "x-session-start": sessionStart,
    }
    if (isTestMode) {
      Object.assign(headers, mockAuthHeaders())
    } else {
      headers.Authorization = `Bearer ${await getAccessTokenSilently()}`
    }

    const response = await fetch(url, { method: "POST", headers, body: JSON.stringify(body) })
    if (!response.ok) throw new Error(await errorMessage(response, fallbackMessage))
    return response
  }
}
